import styled from 'styled-components'
import React, { Fragment, memo, useCallback, useMemo, useState } from 'react'
import { InferLabelFromName } from '../../../utils'
import classNames from 'classnames'
import { Icon } from '../../../components'
import { areEqual } from 'react-window'
import { Modal } from 'antd'

const RowBlock = styled.div`
  color: ${props => props.theme.colorTable.backLightText};
  background: ${props => props.theme.colorTable.backLight};

  &:hover {
    color: ${props => props.theme.colorTable.backLightText};
    background: ${(props) => props.theme.colorTable.backLightHover} !important;
  }

  &.active {
    color: ${props => props.theme.colorTable.listSelectionText} !important;
    background: ${(props) => props.theme.colorTable.listSelection} !important;
  }
`

const getTitle = () => {
  return <h3 className={'m-0'}>Select an item below</h3>
}


const SelectFromGlobal = (props) => {
  if (!props) return null
  const {
    def,
    context,
    autoShow,
    hideButton,
    spaceLeft,
    spaceRight,
  } = props
  const [visible, setVisible] = useState(false)
  const [manuallyClosed, setManuallyClosed] = useState(false)
  const [search, setSearch] = useState('')
  const [activeKey, setActiveKey] = useState('')

  const globalContext = context.global
  const items = globalContext.getChildContext(def.name)

  const keyName = context && context.linkedKeyName && context.linkedKeyName !== '_N_A_'
    ? context.linkedKeyName
    : def.keyName

  const showModal = useCallback(
    () => {
      setVisible(true)
    },
    [visible],
  )

  const hideModal = useCallback(
    () => {
      setVisible(false)
      setManuallyClosed(true)
    },
    [visible],
  )

  const changeSearch = useCallback(
    (val) => {
      setSearch(val)
    },
    [search],
  )

  const buttonLabel = `Select from ${def.label || InferLabelFromName(def.name)}`
  const buttonClasses = classNames('btn btn-outline-secondary dart-btn-outline',
    { 'mr-3': spaceRight, 'ml-3': spaceLeft })
  const SelectButton = useMemo(
    () => (
      <button className={buttonClasses}
              style={{ backgroundColor: '#FFFFFF' }}
              onClick={showModal}>{buttonLabel}</button>
    ),
    [def, showModal],
  )

  const SearchInput = useMemo(
    () => (
      <div className={'mb-2'}>
        <label htmlFor={'FilterByKeyword'}>Filter by keyword</label>
        <input id={'FilterByKeyword'}
               type={'text'}
               value={search}
               onChange={event => changeSearch(event.target.value)}
               className={'form-control rounded-2'}
               autoComplete="off"
        />
      </div>
    ),
    [search],
  )

  const changeActive = useCallback((keyValue) => {
    setActiveKey(keyValue)
  }, [def.name])

  const selectActiveItem = async () => {
    const itemContext = items.elements.find(oc => oc.scope.getProperty(keyName) === activeKey)
    if (itemContext) {
      context.copySimpleObjectValue(itemContext.cleanObject())
    } else {
      console.error('Invalid global selection')
    }
    hideModal()
  }

  // eslint-disable-next-line react/display-name
  const Row = memo(
    ({
       rowItem,
       style,
     }) => {
      const keyValue = rowItem.scope.getProperty(keyName)
      const isActive = keyValue === activeKey
      const itemText = rowItem.getSummary()
        || `(err: summary template produced no text for ${rowItem.typeDef.name} '${keyValue}')`
      if (itemText && (!search || itemText.toLowerCase().includes(search.toLowerCase()))) {
        return (
          <div style={style} key={keyValue} className={'py-1'}>
            <RowBlock
              className={classNames('rounded rounded-2 p-2 cursorPointer', { active: isActive })}
              onClick={() => changeActive(keyValue)}>
              <span><Icon type={isActive ? 'icon-check-circle' : 'icon-circle'}
                          className={classNames('h5 m-0')} style={{ verticalAlign: 0 }}/>
              </span>
              <span className={'mr-5 ml-2'}>{itemText || `(${def.typeName})`}</span>
            </RowBlock>
          </div>
        )
      }
      return null
    },
    areEqual,
  )

  if (autoShow && !visible && !manuallyClosed && items && items.elements && items.elements.length) {
    setVisible(true)
  }

  return (
    <Fragment>
      {hideButton ? null : SelectButton}
      <Modal
        title={getTitle(def.provider, def.typeName, context.typeDefs)}
        className={'app-modal'}
        visible={visible}
        onCancel={hideModal}
        maskClosable={false}
        destroyOnClose={true}
        footer={(<div className={'d-flex'}>
          <button key="OK" className={'btn btn-secondary dart-btn ml-auto'} onClick={selectActiveItem}>SELECT</button>
        </div>)}>
        <div className={'w-100 overflow-auto'} style={{
          minHeight: 200,
          maxHeight: '60vh',
        }}>
          {SearchInput}
          {items && items.elements && items.elements.map(c => (
            <Row rowItem={c} style={{ overflowX: 'hidden' }}/>
          ))}
        </div>
      </Modal>
    </Fragment>
  )
}

export default SelectFromGlobal
